import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { AccountShopsResponse } from "api/models";
import { getShopList } from "../../api/getShopList.api";
import { useCurrentUser } from "../../context/user/user-context";

export const useAccessibleShops = ({
  refetchOnMount = false
}: Pick<UseQueryOptions<AccountShopsResponse>, "refetchOnMount"> = {}) => {
  const user = useCurrentUser();
  const query = useQuery<AccountShopsResponse>({
    queryKey: ["shopData", user.id, user.session, user.role],
    queryFn: getShopList,
    refetchOnWindowFocus: false,
    refetchOnMount,
    retry: false
  });
  return { ...query, loading: query.isLoading };
};
